import ComposeViewState from '../store/schema/ComposeViewState';
import { AttachmentState } from 'owa-attachment-full-data';

export default function getAllAttachments(composeViewState: ComposeViewState): AttachmentState[] {
    const attachmentWell = composeViewState.attachmentWell;
    if (attachmentWell) {
        const { docViewAttachments, imageViewAttachments, inlineAttachments } = attachmentWell;
        return [...docViewAttachments, ...imageViewAttachments, ...inlineAttachments];
    }
    return [];
}
